import _ from 'lodash'
import { CATEGORIES } from '../constants'

const pole = (data) => {
	const poles = data.map(
		({
			id,
			title: { rendered: title },
			content: { rendered: description },
			categories,
			acf: { email },
		}) => {
			const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
			const images = description.match(regx)

			return {
				id,
				title,
				description,
				email,
				categorie: categories[0].toString(),
				image: (!_.isEmpty(images) && images[0]) || null,
			}
		},
	)

	const adPoles = _.filter(
		poles,
		({ categorie }) => categorie === CATEGORIES.POLES.ADMINISTRATIF.id,
	)
	const accPoles = _.filter(
		poles,
		({ categorie }) => categorie === CATEGORIES.POLES.RH_ACCOMPAGNEMENT_FORMATION.id,
	)
	const senPoles = _.filter(
		poles,
		({ categorie }) => categorie === CATEGORIES.POLES.SENSIBILISATION.id,
	)
	const proPoles = _.filter(poles, ({ categorie }) => categorie === CATEGORIES.POLES.PRODUCTION.id)
	const resPoles = _.filter(
		poles,
		({ categorie }) => categorie === CATEGORIES.POLES.RESSOURCERIE.id,
	)

	const polesByCategory = [
		(!_.isEmpty(adPoles) && { [CATEGORIES.POLES.ADMINISTRATIF.label]: adPoles }) || null,
		(!_.isEmpty(accPoles) && { [CATEGORIES.POLES.RH_ACCOMPAGNEMENT_FORMATION.label]: accPoles }) ||
			null,
		(!_.isEmpty(senPoles) && { [CATEGORIES.POLES.SENSIBILISATION.label]: senPoles }) || null,
		(!_.isEmpty(proPoles) && { [CATEGORIES.POLES.PRODUCTION.label]: proPoles }) || null,
		(!_.isEmpty(resPoles) && { [CATEGORIES.POLES.RESSOURCERIE.label]: resPoles }) || null,
	]

	return _.compact(polesByCategory)
}

export default pole
